import { EXTRA_SERVICES_BOOKING } from "@typings/booking";

export const getBookingExtraServiceTranslation = (
  service: EXTRA_SERVICES_BOOKING,
): string => {
  switch (service) {
    case EXTRA_SERVICES_BOOKING.IRONING:
      return "batmaid_pwa_booking.extra_service_ironing";
    case EXTRA_SERVICES_BOOKING.HOME_CLEANING:
      return "batmaid_pwa_booking.extra_service_home_cleaning";
    case EXTRA_SERVICES_BOOKING.INSIDE_CABINETS:
      return "batmaid_pwa_booking.extra_service_inside_cabinets";
    case EXTRA_SERVICES_BOOKING.INSIDE_FRIDGE:
      return "batmaid_pwa_booking.extra_service_inside_fridge";
    case EXTRA_SERVICES_BOOKING.INSIDE_OVEN:
      return "batmaid_pwa_booking.extra_service_inside_oven";
    case EXTRA_SERVICES_BOOKING.LAUNDRY_WASH_AND_DRY:
      return "batmaid_pwa_booking.extra_service_laundry_wash_and_dry";
    case EXTRA_SERVICES_BOOKING.INTERIOR_WINDOWS:
      return "batmaid_pwa_booking.extra_service_interior_windows";
    case EXTRA_SERVICES_BOOKING.BONUS_15:
      return "batmaid_pwa_booking.extra_service_bonus_15";
    default:
      return `batmaid_pwa_booking.extra_service_${service}`;
  }
};
